import React, { useEffect, useState } from 'react';
import AdGenerater from '../../ads/AdGenerater';
import Tv24CurationTab from './Tv24CurationTab';
import Tv24CurationNewAndHotType1 from './Tv24CurationNewAndHotType1';
import Tv24CurationEditorPick2Type2 from './Tv24CurationEditorPick2Type2';
import Tv24CurationNormalType2 from './Tv24CurationNormalType2';
import Tv24CurationNormalType3 from './Tv24CurationNormalType3';
import Tv24CurationEditorPick1Type4 from './Tv24CurationEditorPick1Type4';

export default function Tv24Container(props) {
  const [curationData, setCurationData] = useState({
    newAndHot: null,
    editorPick1: null,
    editorPick2: null,
    normal: null
  });

  useEffect(() => {
    if (props.data) {
      const filterData = (category, titleCondition = () => true) => {
        const filtered = props.data.filter(item => 
          (category ? item.category === category : item.category === undefined || item.category === "") 
          && titleCondition(item.title)
        );
        return filtered.length > 0 ? filtered : [props.data[0]];
      };

      setCurationData({
        newAndHot: filterData("NEW & HOT"),
        editorPick1: filterData("PICK", title => title.includes("명작")),
        editorPick2: filterData("PICK", title => title.includes("월 PICK")),
        normal: filterData(null)
      });
    }
  }, [props.data]);

  useEffect(() => {
    const selectTabsAndObserve = () => {
      const links = document.querySelectorAll('.tab_list_inner');
      console.log('탭 수:', links.length);

      if (links.length === 0) {
        setTimeout(selectTabsAndObserve, 100);
        return;
      }

      const sections = document.querySelectorAll('section');

      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };

      const observerCallback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('id');
            links.forEach((link) => {
              link.classList.remove('current');
              if (link.getAttribute('href') === `#${id}`) {
                link.classList.add('current');
              }
            });
          }
        });
      };

      const observer = new IntersectionObserver(observerCallback, observerOptions);
      sections.forEach((section) => observer.observe(section));

      return () => {
        observer.disconnect();
      };
    };

    selectTabsAndObserve();
  }, []);

  return (
    <>
      {curationData.newAndHot && <Tv24CurationNewAndHotType1 data={curationData.newAndHot[0]} />}
      {curationData.editorPick1 && curationData.editorPick2 && curationData.normal && <Tv24CurationTab data={props.data} />}
      {curationData.editorPick1 && <Tv24CurationEditorPick1Type4 data={curationData.editorPick1[0]} />}
      {curationData.editorPick2 && <Tv24CurationEditorPick2Type2 data={curationData.editorPick2[0]} />}
      {curationData.normal && curationData.normal.map((item, index) => (
        <React.Fragment key={index}>
          <AdGenerater id='24live_web_middle_970_90' w='970' h='90' />
          {index % 2 === 0 ? (
            <Tv24CurationNormalType3 data={item} />
          ) : (
            <Tv24CurationNormalType2 data={item} />
          )}
        </React.Fragment>
      ))}
    </>
  );
}